const enquiryTypes = [
  'General Enquiry',
  'Book a Test Drive',
  'Request a Video',
  'Book an Appointment'
]

export default enquiryTypes
